import { useTranslation } from 'react-i18next';
import React from 'react';
import { CommonFields } from '../common/CommonFields';
import {
  IFormWrapperProps,
  UpdateVendorFormFieldsMap,
} from '../../interfaces';
import { AdditionalFields } from '../../components/AdditionalFields';
import { DomesticAddressFields } from '../mailCheck/DomesticAddressFields';
import { InternationalAddressFields } from './InternationalAddressFields';
import { InternationalBaseFields } from './InternationalBaseFields';
import Heading from '../../../../generic-components/Heading';
import { AchOutTransferFields } from '../achOutTransfer/AchOutTransferFields';
import { DomesticWireTransferFields } from '../domesticWireTransfer/DomesticWireTransferFields';

export const InternationalWireTransferFormWrapper = ({ vendorData, moveType, formMethods, formType, isVendorUpdateMandatory, isUpdateNameRequired }: IFormWrapperProps) => {
  const { t } = useTranslation();
  const reactiveCountry = formMethods.watch(UpdateVendorFormFieldsMap.INTER_COUNTRY);

  const additionalFieldsList = [
    {
      title: t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.ACH_TRANSFER'),
      body: <AchOutTransferFields formMethods={formMethods} />,
    },
    {
      title: t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.DOMESTIC_WIRE'),
      body: <DomesticWireTransferFields formMethods={formMethods} />,
    },
    {
      title: t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.DOMESTIC_ADDRESS'),
      body: <DomesticAddressFields formMethods={formMethods} />,
    },
  ];

  const shouldShowCommonFields = () => {
    if (isUpdateNameRequired) {
      return true;
    }
    return !isVendorUpdateMandatory;
  };

  const shouldShowMainFields = () => {
    if (isVendorUpdateMandatory) {
      return true;
    }
    return !isUpdateNameRequired;
  };

  return (
    <div className='flex flex-col'>
      {shouldShowCommonFields() && <CommonFields isUpdateNameRequired={isUpdateNameRequired} formMethods={formMethods} formType={formType} />}
      {shouldShowMainFields() &&
        <div className='flex flex-col'>
          <InternationalBaseFields
            vendorData={vendorData}
            moveType={moveType}
            dynamicCountry={reactiveCountry}
            formMethods={formMethods}
          />
          <InternationalAddressFields dynamicCountry={reactiveCountry} formMethods={formMethods} />
        </div>}
      {!isVendorUpdateMandatory && !isUpdateNameRequired && <Heading
        id='additionalRecipient'
        title={t('MOVE_MONEY.STEPS.VENDOR_MANAGER.ADDITIONAL_FIELDS.ADDITIONAL_DETAILS')}
        className='font-metricRMedium text-[16px] text-bw08 mt-[32px] mb-[24px]'
      />}
      {!isVendorUpdateMandatory && !isUpdateNameRequired && <AdditionalFields additionalFieldsList={additionalFieldsList} />}
    </div>
  );
};
